/**
 * Date / timestamp formatting helpers.
 *
 * Three distinct shapes are supported because the codebase uses each:
 *  - formatTimestamp(value, fallback): display-friendly date+time (toLocaleString)
 *  - formatDateDisplay(value, fallback): display-friendly date (toLocaleDateString),
 *    tolerant of bare YYYY-MM-DD strings (no UTC drift).
 *  - formatIsoDate(date): Date object -> "YYYY-MM-DD" slice (used for API params).
 */

export function formatTimestamp(value, fallback = '-') {
  if (!value) {
    return fallback;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
}

export function formatDateDisplay(value, fallback = 'Not set') {
  if (!value) {
    return fallback;
  }

  const normalizedValue = String(value).trim();
  if (!normalizedValue) {
    return fallback;
  }

  const date = normalizedValue.includes('T')
    ? new Date(normalizedValue)
    : new Date(`${normalizedValue}T00:00:00`);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleDateString();
}

export function formatIsoDate(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toISOString().slice(0, 10);
}
